import {LitElement, html, css} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { SldsBaseElement } from '../components/slds-base-element.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import store from '../src/store';

@customElement('data-deletion-view')
class DataDeletionView extends connect(store)(SldsBaseElement) {
  render() {
    return html`
    <div class="slds-container_x-large slds-container_center slds-p-around_medium">
      <div class="slds-p-around_large">
        <h1 class="slds-text-heading_large slds-m-bottom_small">How can I delete my account?</h1>

        <p class="slds-m-bottom_medium">
          If you wish to delete your ROFLCOPTER account, please follow these steps:
        </p>

        <ul class="slds-list_dotted slds-m-bottom_large">
          <li class="slds-m-bottom_x-small"><strong>Log In:</strong> Sign in to your ROFLCOPTER account using your credentials.</li>
          <li class="slds-m-bottom_x-small"><strong>Access Settings:</strong> Go to your account settings by clicking on your profile picture in the top right corner and selecting Settings from the dropdown menu, or you can visit this link.</li>
          <li class="slds-m-bottom_x-small"><strong>Look for the Option to Delete Your Account:</strong> In the Account tab, find the option to delete your account and click on it. You may be prompted to confirm your decision.</li>
          <li class="slds-m-bottom_x-small"><strong>Follow Confirmation Steps:</strong> Follow any additional prompts to confirm that you want to permanently delete your account.</li>
        </ul>

        <div class="slds-box slds-theme_warning slds-m-bottom_medium">
          <p><strong>Please Note:</strong> Deleting your account is permanent and cannot be undone. All your posts, comments, and personal data will be removed.</p>
        </div>

        <p class="slds-m-bottom_medium">
          If you wish to delete your data on ROFLCOPTER, please visit this link for more information and instructions on how to proceed.
        </p>

        <p>
          If you have any further questions, feel free to reach out to our support team!
        </p>
      </div>
    </div>
    `;
  }
}
